import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { Navigator } from "src/app/components/menu/navigator";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { MobileToolsService } from "src/app/services/mobile-tools/mobile-tools.service";
import { MarketingService } from 'src/app/services/marketing/marketing.service';
import { UtilsService } from "src/app/services/utils/utils.service";
import { UniqueIDService } from "src/app/services/unique-id/unique-id.service";
import { EventsService } from "src/app/services/event/event.service";

@Component({
  selector: 'app-env-selector',
  templateUrl: './env-selector.component.html',
  styleUrls: ['./env-selector.component.scss'],
})
export class EnvSelectorComponent implements OnInit {

  public isAuthenticated: boolean = false;
  public splashPageSettings;
  public displayButtons: Boolean = true;
  public splashPageState = '';
  private timeout = 1000;

  public tapCount: number = 0;
  public tapTimeoutID: any = 0;
  public deviceId: any;
  public environment: any = "";
  public showDeviceId: boolean = false
  public isEnvSelected: boolean = false;

  constructor(public config: ConfigService,
    public platform: Platform,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public utils: UtilsService,
    public screenOrientation: ScreenOrientation,
    private appstorageTsService: AppstorageTsService,
    private mobileTools: MobileToolsService,
    private uniqueIDProvider: UniqueIDService,
    private events: EventsService,
    private marketingService: MarketingService) {
  }

  async ngOnInit() {
    console.log("TabLandingPage")
    if (this.platform.is('capacitor')) {
      this.uniqueIDProvider.getSelectorID().then(
        response => {
          console.log("uniqueIDProvider.getSelectorID()", response)
          this.deviceId = response
        },
        reject => {
          console.log("error uniqueIDProvider.getSelectorID()", reject)
          this.deviceId = "Not available!"
        }
      );

      await this.mobileTools.checkEnvironmentSelector()
      console.log("show selector?", this.mobileTools.shouldSelectEnvironment)

      if (!this.mobileTools.shouldSelectEnvironment) {
        console.log("splashPageInit for mobile app")
        this.splashPageInit()
      }
    }
    else {
      console.log("splashPageInit for web")
      this.splashPageInit();
    }
  }

  private splashPageInit() {
    console.log("TabLandingPage splashPageInit")

    if (this.platform.is("capacitor")) {
     //this.hasNoJurisdictionCheck();
      this.goTo();
    }else {
      //web - remember the user selection for splash site
      this.goTo();
    }
  }

  public async goTo(url?, stateCode?) {
    console.log("TabLandingPage goTo", url, stateCode, this.environment)
    if(this.platform.is('capacitor')) {
      const isNeedToUpdate = await this.mobileTools.checkForUpdate();
      if(!isNeedToUpdate){
        this.events.publish("event:remove:env:selector");
      }
    } else {
      this.events.publish("event:remove:env:selector");
    }
   // this.siteLocationService.goTo(url, stateCode, this.environment);
  }
  private hasNoJurisdictionCheck() {
    if (this.config.clientAppWithNoJurisdiction()) {
      return this.goTo("", "");

    }
  }
  //web - to retrieve stored jurisdiction state URL
  public getStoredStateURL(stateObj) {
    let pageSettings = this.config.getConfig().FEATURE_APP_SPLASH_SETTINGS;
    let pageSettingsArray = JSON.parse(pageSettings);

    let redirectPathURL = pageSettingsArray.filter(o => o.jurisdiction === stateObj);
    if (redirectPathURL)
      return redirectPathURL[0].url;

    return window.location.href;
  }

  // environment selector logic
  onLogoTap() {
    if (this.platform.is('capacitor')) {
      this.tapCount += 1;
      // console.log("environment-selector onLogoTap", this.tapCount)

      clearTimeout(this.tapTimeoutID);

      if (this.tapCount >= 10) {
        this.showDeviceId = true
      }
      else {
        this.tapTimeoutID = setTimeout(() => {
          this.tapCount = 0;
        }, 5000)
      }
    }
  }

  onEnvChange() {
    console.log('environment-selector onEnvChange', this.environment);
  }

  async onGoToEnvironment() {
    console.log('environment-selector onGoToEnvironment', this.environment);

    this.isEnvSelected = true
   await this.config.reloadConfig(this.environment);
    this.config.isLoaded().then(() => {
      this.splashPageInit();
    })
  }
  isEnvironmentSelected() {
    return this.environment != "" ? true : false;
  }
  //end environment selector logic

}
